/**
 * District names from chocolate-app
 * lib/regional/HK/constant/district_list_hk.dart.
 * addr_line_3 stores either the English or Traditional Chinese name.
 */
export type HkDistrictLanguage = "en" | "zh-Hant";

export type HkDistrict = {
  readonly en: string;
  readonly "zh-Hant": string;
};

export const HK_DISTRICTS: readonly HkDistrict[] = [
  { en: "HK Island: Central and Western", "zh-Hant": "香港島: 中西區" },
  { en: "HK Island: Eastern", "zh-Hant": "香港島: 東區" },
  { en: "HK Island: Southern", "zh-Hant": "香港島: 南區" },
  { en: "HK Island: Wan Chai", "zh-Hant": "香港島: 灣仔區" },
  { en: "Kowloon: Kowloon City", "zh-Hant": "九龍: 九龍城區" },
  { en: "Kowloon: Kwun Tong", "zh-Hant": "九龍: 觀塘區" },
  { en: "Kowloon: Sham Shui Po", "zh-Hant": "九龍: 深水埗區" },
  { en: "Kowloon: Wong Tai Sin", "zh-Hant": "九龍: 黃大仙區" },
  { en: "Kowloon: Yau Tsim Mong", "zh-Hant": "九龍: 油尖旺區" },
  { en: "New Territories: Islands", "zh-Hant": "新界: 離島區" },
  { en: "New Territories: Kwai Tsing", "zh-Hant": "新界: 葵青區" },
  { en: "New Territories: North", "zh-Hant": "新界: 北區" },
  { en: "New Territories: Sai Kung", "zh-Hant": "新界: 西貢區" },
  { en: "New Territories: Sha Tin", "zh-Hant": "新界: 沙田區" },
  { en: "New Territories: Tai Po", "zh-Hant": "新界: 大埔區" },
  { en: "New Territories: Tsuen Wan", "zh-Hant": "新界: 荃灣區" },
  { en: "New Territories: Tuen Mun", "zh-Hant": "新界: 屯門區" },
  { en: "New Territories: Yuen Long", "zh-Hant": "新界: 元朗區" },
];

export const districtNames = (
  language: HkDistrictLanguage
): readonly string[] => HK_DISTRICTS.map((district) => district[language]);

const matchDistrict = (value: string): HkDistrict | undefined => {
  const trimmed = value.trim();
  return HK_DISTRICTS.find(
    (district) => district.en === trimmed || district["zh-Hant"] === trimmed
  );
};

export const districtLanguageOf = (value: string): HkDistrictLanguage =>
  matchDistrict(value)?.["zh-Hant"] === value.trim() ? "zh-Hant" : "en";

export const translateDistrict = (
  value: string,
  language: HkDistrictLanguage
): string => matchDistrict(value)?.[language] ?? value;
